export default function nl2br(text: string) {
    // return text.replace(/\n/g, "<br />");
    return text.split("\n").map((it, i) => (
        <span key={"x" + i} className="mt-3 block">
            {it}
        </span>
    ));
}
